import { generatePath } from "react-router-dom";
import {
  Table,
  TableBodyRow,
  Td,
  H2,
  Input,
  Th,
} from "@collabodoc/component-library";
import { VIEWS } from "../../URLS";
import { Col, Card } from "react-bootstrap";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const StyledInput = styled(Input)`
  width: 50px;
  background-color: #fff;
  border: ${(props) => props.showError && "solid 2px red"};

  &:focus {
    border: ${(props) => props.showError && "solid 2px red"};
  }

  &:disabled {
    background-color: #f2f2f2;
    cursor: not-allowed;
  }

  /*Remove arrows from number input*/

  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  margin-top: 10px;
`;

const StyledTd = styled(Td)`
  vertical-align: middle !important;
`;

const InputTd = styled(Td)`
  cursor: default;
`;

const getNumberOrNull = (elem) =>
  elem.value === "" ? null : elem.valueAsNumber;

const getValueOrEmptyString = (value) => (value == null ? "" : value);

const SymptomTypeItems = ({
  symptomtypeItems = [],
  handleRemoveItem,
  handleItemListChange,
}) => {
  const navigate = useNavigate();

  const treatmentItems = symptomtypeItems.filter((x) => x.itemType === 2);
  const statusItems = symptomtypeItems.filter((x) => x.itemType === 1);

  const sortedTreatmentItems =
    treatmentItems &&
    treatmentItems.sort((a, b) => {
      if (a.column === b.column) {
        return a.index < b.index ? -1 : 1;
      } else {
        return a.column < b.column ? -1 : 1;
      }
    });

  const sortedStatusItems =
    statusItems &&
    statusItems.sort((a, b) => {
      if (a.column === b.column) {
        return a.index < b.index ? -1 : 1;
      } else {
        return a.column < b.column ? -1 : 1;
      }
    });

  return (
    <Col lg={{ span: 8, offset: 4 }}>
      <Card>
        <Card.Header>
          <H2>Bedömning/Behandling</H2>
        </Card.Header>
        <Card.Body>
          <Table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Grupp</th>
                <th>Fras</th>
                <th>Sida</th>
                <th>Kolumn</th>
                <th>Ordning</th>
              </tr>
            </thead>
            <tbody>
              {sortedTreatmentItems.length < 1 ? (
                <TableBodyRow>
                  <Td>Inga tillhörande items</Td>
                </TableBodyRow>
              ) : (
                sortedTreatmentItems.map((item) => (
                  <TableBodyRow key={item.itemTemplateId}>
                    <Td
                      onClick={() =>
                        navigate(
                          generatePath(VIEWS.ITEM, {
                            itemId: item.itemTemplateId,
                          }),
                        )
                      }
                    >
                      {item.itemTemplateId}
                    </Td>
                    <Td
                      onClick={() =>
                        navigate(
                          generatePath(VIEWS.ITEM, {
                            itemId: item.itemTemplateId,
                          }),
                        )
                      }
                    >
                      {item.groupTitle}
                    </Td>
                    <Td
                      onClick={() =>
                        navigate(
                          generatePath(VIEWS.ITEM, {
                            itemId: item.itemTemplateId,
                          }),
                        )
                      }
                    >
                      {item.phrase}
                    </Td>
                    <InputTd title={"sida"}>
                      {" "}
                      <StyledInput
                        disabled
                        type={"number"}
                        value={getValueOrEmptyString(item.groupIndex)}
                        showError={item.groupIndex == null}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          handleItemListChange(
                            item.itemTemplateId,
                            item.phrase,
                            item.groupTitle,
                            item.itemType,
                            getNumberOrNull(e.target),
                            item.index,
                            item.column,
                          )
                        }
                      />
                    </InputTd>
                    <InputTd title={"kolumn"}>
                      <StyledInput
                        type={"number"}
                        value={getValueOrEmptyString(item.column)}
                        showError={item.column == null}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          handleItemListChange(
                            item.itemTemplateId,
                            item.phrase,
                            item.groupTitle,
                            item.itemType,
                            item.groupIndex,
                            item.index,
                            getNumberOrNull(e.target),
                          )
                        }
                      />
                    </InputTd>
                    <InputTd title={"ordning"}>
                      {" "}
                      <StyledInput
                        type={"number"}
                        value={getValueOrEmptyString(item.index)}
                        showError={item.index == null}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          handleItemListChange(
                            item.itemTemplateId,
                            item.phrase,
                            item.groupTitle,
                            item.itemType,
                            item.groupIndex,
                            getNumberOrNull(e.target),
                            item.column,
                          )
                        }
                      />
                    </InputTd>
                    <StyledTd
                      onClick={(e) => handleRemoveItem(e, item.itemTemplateId)}
                    >
                      <StyledIcon icon={faTrashCan} />
                    </StyledTd>
                  </TableBodyRow>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default SymptomTypeItems;
